import React from 'react';

const DEFAULT_TEXT_COLOR = '#505258';

export interface TextColorPickerIconProps {
  iconColor?: string;
  backgroundColor?: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  label: string;
}

export const TextColorPickerIcon: React.FC<TextColorPickerIconProps> = ({
  iconColor,
  backgroundColor,
  isDisabled,
  isSelected,
  label,
}) => (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={label}
  >
    {/* eslint-disable-next-line no-restricted-syntax -- Dynamic iconColor requires inline SVG; sprite cannot support per-instance stroke color */}
    <rect
      x={0.364847}
      y={0.364847}
      width={20.2703}
      height={20.2703}
      rx={4.13515}
      stroke="#0B1228"
      strokeOpacity={0.14}
      fill={backgroundColor}
    />
    {isSelected ? (
      /* Checkmark for selected state */
      /* eslint-disable-next-line no-restricted-syntax -- Dynamic iconColor requires inline SVG */
      <path
        d="M7 10.5L9.5 13L14 8"
        stroke={iconColor ?? DEFAULT_TEXT_COLOR}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    ) : (
      /* "A" letter for text color */
      /* eslint-disable-next-line no-restricted-syntax -- Dynamic iconColor requires inline SVG; sprite cannot support per-instance stroke color */
      <path
        d="M6.375 15.375V15.0183L7.59412 11.8079M14.4603 15.375V15.0183L13.247 11.8079M13.247 11.8079L10.9103 5.625H9.94205L7.59412 11.8079M13.247 11.8079H7.59412"
        stroke={iconColor ?? DEFAULT_TEXT_COLOR}
        strokeWidth={1.275}
        strokeLinejoin="round"
        opacity={isDisabled ? 0.5 : 1}
      />
    )}
  </svg>
);
